module.exports = "pegasus/assets/badges-card.png";